import { z } from 'zod'

import { authSchema } from '@maestro/commerce-blocks/schemas/forms/auth.schema'
import { m } from '@maestro/commerce-blocks/schemas/helpers'

export const loginFormSchema = authSchema.extend({
  password: z.string().nonempty(m('password.required')).max(100),
})
